import * as tslib_1 from "tslib";
import { isGroupTableQuery, getGroupIdFromTableQuery } from 'owa-group-common';
import { lazyIsGroupOwner, lazyIsPrivateUnjoinedGroup } from 'owa-group-utils';
import { isDumpsterTable, listViewStore, MailRowDataPropertyGetter, } from 'owa-mail-list-store';
import { isDumpsterSearchTable } from 'owa-mail-search-store';
import { composeStore } from 'owa-mail-compose-store';
export default function getMailMenuItemShouldDisable(menuItem) {
    var tableView = listViewStore.tableViews.get(listViewStore.selectedTableViewId);
    switch (menuItem) {
        case 19 /* NewMessage */:
            return isNewMessageDisabled(tableView);
        case 6 /* Delete */:
            return isDeleteDisabled(tableView);
        default:
            return false;
    }
}
// Show new message as disabled
// - when we in a dumpster table
// - when we are in a private unjoined group
// - when a new message is still in the process of being created
function isNewMessageDisabled(tableView) {
    var tableQuery = tableView.tableQuery;
    var isDumpsterOrDumpsterSearchTable = isDumpsterTable(tableQuery) || isDumpsterSearchTable(tableQuery);
    if (isDumpsterOrDumpsterSearchTable) {
        return true;
    }
    if (isGroupTableQuery(tableQuery)) {
        var isPrivateUnjoinedGroup = lazyIsPrivateUnjoinedGroup.tryImportSync();
        return (isPrivateUnjoinedGroup && isPrivateUnjoinedGroup(getGroupIdFromTableQuery(tableQuery)));
    }
    if (composeStore.newMessageCreationInProgress) {
        return true;
    }
    return false;
}
// Show delete as disabled
// - when we are in a group, we are not the group owner, AND
// --- we have multiple rows selected OR
// --- we do not have canDelete permissions on the message
function isDeleteDisabled(tableView) {
    var tableQuery = tableView.tableQuery;
    if (isGroupTableQuery(tableQuery)) {
        var isGroupOwner = lazyIsGroupOwner.tryImportSync();
        if (!(isGroupOwner && isGroupOwner(getGroupIdFromTableQuery(tableQuery)))) {
            var selectedKeys = tslib_1.__spread(tableView.selectedRowKeys.keys());
            return (selectedKeys.length !== 1 ||
                !MailRowDataPropertyGetter.getCanDelete(selectedKeys[0], tableView));
        }
    }
    return false;
}
//# sourceMappingURL=getMailMenuItemShouldDisable.js.map